<div class="container">
  @if (data.headline) {
    <h4 class="top-header">{{ data.translate ? data.headline : data.headline }} {{ getHeadlineData() }}</h4>
  }
  <div style="padding: 2em">
    @if (!data.headline) {
      <h4>
        {{ data.translate ? getTranslatedValue(data.msg) : data.msg }}
      </h4>
    }
    @if (data.headline && data.msg) {
      <p style="margin-bottom: 20px">
        {{ data.translate ? getTranslatedValue(data.msg) : data.msg }}
      </p>
    }
    @if (data?.dropdownValues?.length) {
      <importer-dropdown
        [label]="$safeNavigationMigration(data?.dropdownLabel)"
        [items]="data.dropdownValues"
        [shadow]="true"
        [displayFn]="dropdownDisplayFn"
        [(ngModel)]="selectedDropdownValue"></importer-dropdown>
    }
    @if (data?.provideInput) {
      <div class="comment-text">
        <input
          title="text"
          name="text"
          id="text"
          placeholder="Enter comment..."
          [(ngModel)]="providedInput" />
      </div>
    }
    <div class="buttons">
      @if (data.cancelMsg) {
        <coin-v2-button
          [type]="'secondary'"
          [icon]="'close'"
          [iconPos]="'right'"
          [text]="data.translate ? data.cancelMsg : data.cancelMsg"
          (click)="cancel()"></coin-v2-button>
      }

      <coin-v2-button
        [type]="'primary'"
        [icon]="'save'"
        [iconPos]="'right'"
        [text]="data.translate ? data.confirmMsg : data.confirmMsg"
        [disabled]="data?.inputMandatory ? !providedInput?.trim() : false"
        (click)="confirm()"></coin-v2-button>
    </div>
  </div>
</div>
